import { useQuery } from 'react-query'
import { BASE_API_URL } from 'constants/env'
import { API_METHODS } from 'constants/api-methods'
import { apiHeaders } from 'utils/api-headers'
import { store } from 'index'
import { handleErrors } from 'utils/handle-errors'
import { PhysicalPhone } from 'interfaces/physical-phone'

const fetchPhysicalPhoneDetail = async (
  phoneId: string
): Promise<PhysicalPhone> => {
  let response = await fetch(
    `${BASE_API_URL}/api/v4/phone_number_service/physical_phones/${phoneId}?include=user,appleIdConfig`,
    {
      method: API_METHODS.GET,
      headers: apiHeaders(store.getState()),
    }
  )
  response = handleErrors(response)
  return response.json()
}

const usePhysicalPhoneDetail = (phoneId?: string) => {
  return useQuery(
    ['physical-phone-detail', phoneId],
    () => fetchPhysicalPhoneDetail(phoneId!),
    {
      enabled: !!phoneId,
      staleTime: 30000,
      retry: 2,
    }
  )
}

export default usePhysicalPhoneDetail
